export default __webpack_public_path__ + "static/media/Lighthouse_Device.9de05aeb.png";